import React from "react";
import "./popularPriceCard.css";

const PopularPriceCard = ({
  title,
  price,
  accounts,
  headline,
  list,
  discount,
  saveMonth,
  saveYearly,
}) => {
  return (
    <div className="popular-price-card-container">
      <div className="popular">
        Most Popular <img src="./images/PVX/Star.svg" alt="star" />
      </div>
      <div className="intro">
        <div className="title">{title}</div>
        <div className="price">
          <span className="amount">{price}</span>
          <span className="period"> /month</span>
        </div>
        <div className="save">Save per month ({saveMonth})</div>
        <div className="discount">
          {discount}% Additional OFF on Yearly Plan
        </div>
        <div className="save">Save per year ({saveYearly})</div>
        <div className="accounts">{accounts}</div>
        {/* <div className="headline">{headline}</div> */}
      </div>
      <div className="body">
        <div className="list">
          {list.map((item, index) => (
            <div className="item" key={index}>
              <img src="./images/PVX/Check.svg" alt="check" />
              <span>{item}</span>
            </div>
          ))}
        </div>
        <div className="button">Get Started</div>
      </div>
    </div>
  );
};

export default PopularPriceCard;
